import { forkJoin } from 'rxjs';
import { Component, OnInit } from '@angular/core';

import { SnackbarService } from './../../../services/snackbar.service';
import { IBatchConfig } from './../../../models/batch-config';
import { TransferConfigEnum, IHeaderItem } from 'src/app/models/generic';
import { ApiTransferConfigService } from './../../../services/api/api-transfer-config.service';
import { ICustomSelect } from './../../../models/generic';

@Component({
  selector: 'app-configuracoes-repasse',
  templateUrl: './configuracoes-repasse.component.html',
  styleUrls: ['./configuracoes-repasse.component.scss']
})
export class ConfiguracoesRepasseComponent implements OnInit {
  ConfigTransferEnum = TransferConfigEnum;

  automaticBatches: IBatchConfig[] = [];
  manualBatches: IBatchConfig[] = [];

  bankOpts: ICustomSelect[] = [];
  channelOpts: ICustomSelect[] = [];
  invoiceOpts: ICustomSelect[] = [];
  contractOpts: ICustomSelect[] = [];
  paymentOpts: ICustomSelect[] = [];

  items = [1, 2];
  automaticHeaderOptions: IHeaderItem[] = [
    { label: 'Banco', flexSize: 3, justify: 'flex-start' },
    { label: 'Canal de Vendas', flexSize: 3, justify: 'flex-start' },
    { label: '', flexSize: 1 }
  ];
  manualHeaderOptions: IHeaderItem[] = [
    { label: 'Banco', flexSize: 1, justify: 'center' },
    { label: 'Canal de Vendas', flexSize: 1, justify: 'center' },
    { label: 'Status Contrato', flexSize: 1, justify: 'center' },
    { label: 'Status Faturamento', flexSize: 1, justify: 'center' },
    { label: 'Status Pagamento', flexSize: 1, justify: 'center' }
  ];
  emptyOption: ICustomSelect = { id: 'Nenhum', name: 'Nenhum' };

  constructor(
    private _batchConfigService: ApiTransferConfigService,
    private _snackbarService: SnackbarService
  ) {}

  ngOnInit(): void {
    this.getBankAndChannelConfig();
    this.getStatusConfig();
    this.getAllBatchConfig();
  }

  getBankAndChannelConfig(): void {
    const bank$ = this._batchConfigService.getBank();
    const channel$ = this._batchConfigService.getChannel();

    const bankAndChannel$ = forkJoin([bank$, channel$]);

    bankAndChannel$.subscribe({
      next: ([banks, channels]) => {
        this.bankOpts = banks;
        this.channelOpts = channels;
      }
    });
  }

  getStatusConfig(): void {
    const invoice$ = this._batchConfigService.getInvoiceStatus();
    const contract$ = this._batchConfigService.getContractStatus();
    const payment$ = this._batchConfigService.getPaymentStatus();

    const status$ = forkJoin([invoice$, contract$, payment$]);

    status$.subscribe({
      next: ([invoices, contracts, payments]) => {
        this.invoiceOpts = invoices;
        this.contractOpts = contracts;
        this.paymentOpts = payments;

        this.paymentOpts.unshift(this.emptyOption);
      }
    });
  }

  getAllBatchConfig(): void {
    const automatic$ = this._batchConfigService.getBatchConfig('Automatic');
    const manual$ = this._batchConfigService.getBatchConfig('Manual');

    const configs$ = forkJoin([automatic$, manual$]);

    configs$.subscribe({
      next: ([automatics, manuals]) => {
        this.automaticBatches = automatics.Data;
        this.manualBatches = manuals.Data;
      }
    });
  }

  addBatchConfig(config: IBatchConfig, type: 'Manual' | 'Automatic'): void {
    const batchConfig: IBatchConfig = {
      Bank: config.Bank,
      Channel: config.Channel,
      Type: type
    };

    this.saveBatchConfig(batchConfig, type);
  }

  saveBatchConfig(config: IBatchConfig, type: 'Manual' | 'Automatic'): void {
    this._batchConfigService.createBatchConfig(config).subscribe({
      next: (newBatchConfig) => {
        type === 'Automatic'
          ? this.automaticBatches.push(newBatchConfig)
          : this.manualBatches.push(newBatchConfig);

        this._snackbarService.openSnackBar(
          'Parametro criado!',
          'success',
          2000
        );
      }
    });
  }

  handleDeleteBatchConfig(
    batchConfigId: string,
    type: 'Automatic' | 'Manual'
  ): void {
    switch (type) {
      case 'Automatic':
        this.automaticBatches = this.automaticBatches.filter(
          (batch) => batch.BatchConfigId !== batchConfigId
        );
        break;

      case 'Manual':
        this.manualBatches = this.manualBatches.filter(
          (batch) => batch.BatchConfigId !== batchConfigId
        );
        break;
    }
  }
}
